import { render, staticRenderFns } from "./TemarioCursoVersion.vue?vue&type=template&id=feb85c4e&"
import script from "./TemarioCursoVersion.vue?vue&type=script&lang=js&"
export * from "./TemarioCursoVersion.vue?vue&type=script&lang=js&"
import style0 from "./TemarioCursoVersion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports